// extracted by mini-css-extract-plugin
export default {"shiftText":"OrderShiftLink_shiftText__rhsL8","shiftLink":"OrderShiftLink_shiftLink__umG-e"};